import axios from "axios";
import {
  FETCH_ADMIN_ANALYTICS_REQUEST,
  FETCH_ADMIN_ANALYTICS_SUCCESS,
  FETCH_ADMIN_ANALYTICS_FAILURE,
  FETCH_QUESTION_ANALYTICS_REQUEST,
  FETCH_QUESTION_ANALYTICS_SUCCESS,
  FETCH_QUESTION_ANALYTICS_FAILURE,
  FETCH_STUDENT_DETAILS_REQUEST,
  FETCH_STUDENT_DETAILS_SUCCESS,
  FETCH_STUDENT_DETAILS_FAILURE,
  CLEAR_ADMIN_ANALYTICS
} from './AdminAnalyticsTypes';

// Fetch all dashboard analytics from cache (auto-seeds on first load)
export const fetchAdminAnalytics = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_ADMIN_ANALYTICS_REQUEST });
      dispatch({ type: FETCH_QUESTION_ANALYTICS_REQUEST });

      const res = await axios.post("/fetchAdminDashboardCached");
      const data = res.data;

      dispatch({
        type: FETCH_ADMIN_ANALYTICS_SUCCESS,
        payload: {
          students: data.students || [],
          totalStudents: data.totalStudents || 0,
          overallStats: data.overallStats || {},
          subjectStats: data.subjectStats || []
        }
      });

      if (data.questionAnalytics) {
        dispatch({
          type: FETCH_QUESTION_ANALYTICS_SUCCESS,
          payload: data.questionAnalytics
        });
      }

      return { success: true };
    } catch (error) {
      const errMsg = error.response?.data?.error || error.message;
      console.error('Error fetching admin analytics:', errMsg);
      dispatch({
        type: FETCH_ADMIN_ANALYTICS_FAILURE,
        payload: errMsg
      });
      dispatch({
        type: FETCH_QUESTION_ANALYTICS_FAILURE,
        payload: errMsg
      });
      return { success: false, error: errMsg };
    }
  };
};

// No-op: question analytics is now included in fetchAdminAnalytics
export const fetchQuestionAnalytics = () => {
  return async () => {
    return { success: true };
  };
};

// Fetch detailed analytics for a specific student (backend endpoint)
export const fetchStudentDetails = (userHandle) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_STUDENT_DETAILS_REQUEST });

      const res = await axios.post("/fetchAdminStudentDetails", { userHandle });

      dispatch({
        type: FETCH_STUDENT_DETAILS_SUCCESS,
        payload: res.data
      });

      return { success: true, data: res.data };
    } catch (error) {
      const errMsg = error.response?.data?.error || error.message;
      console.error('Error fetching student details:', errMsg);
      dispatch({
        type: FETCH_STUDENT_DETAILS_FAILURE,
        payload: errMsg
      });
      return { success: false, error: errMsg };
    }
  };
};

// Clear analytics data
export const clearAdminAnalytics = () => {
  return { type: CLEAR_ADMIN_ANALYTICS };
};
